export const INTENT_ALL_DATES_LABEL = "All Dates";

export const INTENT_CADENCE_OPTIONS: Array<{ value: number; label: string }> = [
  { value: 1, label: "Last Week" },
  { value: 2, label: "Last 2 Weeks" },
  { value: 3, label: "Last 3 Weeks" },
  { value: 4, label: "Last Month" },
];

export function getIntentCadenceLabel(numberOfCadences: number | null): string {
  if (numberOfCadences === null) return INTENT_ALL_DATES_LABEL;
  const match = INTENT_CADENCE_OPTIONS.find(
    (o) => o.value === numberOfCadences
  );
  return match?.label ?? `${numberOfCadences} weeks`;
}

/**
 * Tooltip section type for intent filter tooltips
 */
export type TooltipSection = {
  title: string;
  description?: string;
};

/**
 * Buyer's Journey tooltip content
 */
export const BUYERS_JOURNEY_TOOLTIP_SECTIONS: TooltipSection[] = [
  {
    title: "Evaluating",
    description:
      "Using Natural Language Processing, these signals detect language in a user's web activity related to pricing or buying. Likely indicating the user may be further along their buyer's journey",
  },
  {
    title: "Researching",
    description:
      "Web activity indicating that users are actively engaging with specific intent topics",
  },
];

/**
 * Known context type names from the API
 */
export const CONTEXT_TYPES = [
  "Displacement",
  "Whitespace",
  "Complementary",
  "Expansion",
] as const;

export type ContextTypeName = (typeof CONTEXT_TYPES)[number];

/**
 * Intent Context type descriptions
 */
export const CONTEXT_TYPE_DESCRIPTIONS: Record<ContextTypeName, string> = {
  Displacement:
    "Company is researching or evaluating a product where we already detect an install of a competitive product from a different vendor",
  Whitespace:
    "Company is researching or evaluating a product or product category that we don't detect as currently installed",
  Complementary:
    "Company is researching or evaluating a complementary product or product category",
  Expansion:
    "Company is researching or evaluating a product or product category where we already detect an install from the same vendor associated with the intent signal",
};

/**
 * Intent Context tooltip content
 */
export const INTENT_CONTEXT_TOOLTIP_SECTIONS: TooltipSection[] = [
  {
    title: "Displacement",
    description: CONTEXT_TYPE_DESCRIPTIONS.Displacement,
  },
  {
    title: "Whitespace",
    description: CONTEXT_TYPE_DESCRIPTIONS.Whitespace,
  },
  {
    title: "Complementary",
    description: CONTEXT_TYPE_DESCRIPTIONS.Complementary,
  },
  {
    title: "Expansion",
    description: CONTEXT_TYPE_DESCRIPTIONS.Expansion,
  },
];
